import { put, getContext } from 'redux-saga/effects'
import importer from 'common/importer'
const { getMessages } = importer('GraphQL/Queries')
const { arrayFilter } = importer('Helpers/sort', null)
const PublicContentActions = importer('Stores/PublicContent/Actions')
const { getSFDonorMsgs } = importer('Helpers/getSFDonorMessages', null)
import i18next from 'i18next';

export default function * main ({ sfid, type_c, active_c }) {
  try {
    const isSpanish = i18next.language === 'es-MX'
    yield put(PublicContentActions.getMessagesLoading())
    const apolloClient = yield getContext('client')
    const query = getMessages
    const {data, error} = yield apolloClient.query({query, variables: {isSpanish : isSpanish } })
    if (error) {
      throw error
    }
    const messages = data.salesforce_message__c
    const webMessages = messages.filter(item => item.device_type__c === 'Web' || item.device_type__c === 'Both')
    const filtered = yield arrayFilter(webMessages, 'centerID', 'donation_center__c')
    const sfDonorMessages = getSFDonorMsgs(sfid, filtered)
    yield put(PublicContentActions.getMessagesSuccess({ filtered, messages, sfDonorMessages }))
  } catch (error) {
    yield put(PublicContentActions.getMessagesFailure(error))
  }
}
